webpackJsonp([12879921626349],{

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d)},e.onerror=function(){console.error("could not download file")},e.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null},j.readAsDataURL(a)}else{var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l)},4E4)}});f.saveAs=a.saveAs=a,"undefined"!=typeof module&&(module.exports=a)});
	
	//# sourceMappingURL=FileSaver.min.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\n.form__thankyou a:not(.link-email):after {\n   content: url(/svg/arrow.svg)!important;\n}\n\n.form__thankyou .buttonWrapper{\n   padding-top:2em;\n   display:block;\n}\n"], ["\n\n.form__thankyou a:not(.link-email):after {\n   content: url(/svg/arrow.svg)!important;\n}\n\n.form__thankyou .buttonWrapper{\n   padding-top:2em;\n   display:block;\n}\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  height: 4rem;\n  width: 4rem;\n  position: absolute;\n  top: 3rem;\n  right: 3rem;\n  color: ", ";\n  cursor: pointer;\n\ttransition: color ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(45deg);\n  }\n  &:before {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(-45deg);\n  }\n\t&:hover{\n\t\tcolor: #66523e;\n\n\t}\n"], ["\n  height: 4rem;\n  width: 4rem;\n  position: absolute;\n  top: 3rem;\n  right: 3rem;\n  color: ", ";\n  cursor: pointer;\n\ttransition: color ", ";\n\n  &:after {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(45deg);\n  }\n  &:before {\n    content: '';\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: currentColor;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: rotate(-45deg);\n  }\n\t&:hover{\n\t\tcolor: #66523e;\n\n\t}\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n   width: 90%;\n   max-width: 76rem;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   .btn {\n      margin: ", "rem auto auto auto;\n      flex-basis: 53%;\n   }\n   ", "\n   ", ";\n"], ["\n   width: 90%;\n   max-width: 76rem;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   .btn {\n      margin: ", "rem auto auto auto;\n      flex-basis: 53%;\n   }\n   ", "\n   ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t"], ["\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    padding-top: 0;\n    display:block;\n  "], ["\n    padding-top: 0;\n    display:block;\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n   border-bottom: 1px solid ", ";\n   width: calc(50% - 1rem);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"], ["\n   border-bottom: 1px solid ", ";\n   width: calc(50% - 1rem);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n\t\twidth: 100%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n    display:block;\n    margin-bottom: 0;\n\t"], ["\n\t\twidth: 100%;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n    display:block;\n    margin-bottom: 0;\n\t"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n   border-bottom: 1px solid ", ";\n   width: calc(100%);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"], ["\n   border-bottom: 1px solid ", ";\n   width: calc(100%);\n   display: inline-block;\n   margin-bottom: 0rem;\n   @supports (display: flex) {\n      display: block;\n   }\n\n   ", ";\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n   position: relative;\n   width: auto;\n   flex: 0 0 auto;\n   text-align: left;\n   font-size: 1.4rem;\n   background: ", ";\n   color: ", ";\n   text-decoration: underline;\n   margin-top: ", "rem;\n   padding: 1.2rem 1.75rem;\n   cursor: pointer;\n   transition: margin-left .3s;\n   text-decoration: none;\n\n   :after {\n      content: '\u2192';\n      margin-left: .5rem;\n      transition: margin-left .5s;\n      text-decoration: none;\n   }\n\n   :hover:after {\n      margin-left: .9rem;\n   }\n\n   span {\n      text-decoration: underline;\n   }\n"], ["\n   position: relative;\n   width: auto;\n   flex: 0 0 auto;\n   text-align: left;\n   font-size: 1.4rem;\n   background: ", ";\n   color: ", ";\n   text-decoration: underline;\n   margin-top: ", "rem;\n   padding: 1.2rem 1.75rem;\n   cursor: pointer;\n   transition: margin-left .3s;\n   text-decoration: none;\n\n   :after {\n      content: '\u2192';\n      margin-left: .5rem;\n      transition: margin-left .5s;\n      text-decoration: none;\n   }\n\n   :hover:after {\n      margin-left: .9rem;\n   }\n\n   span {\n      text-decoration: underline;\n   }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  padding: 1rem 0;\n\n  /* width: 100%; */\n  /* font-family: \"Salome Fine\"; */\n  /* color: ", "; */\n  /* text-transform: uppercase; */\n  /* font-size: 3rem; */\n  /* text-align: center; */\n  /* margin-bottom: 3rem; */\n"], ["\n  padding: 1rem 0;\n\n  /* width: 100%; */\n  /* font-family: \"Salome Fine\"; */\n  /* color: ", "; */\n  /* text-transform: uppercase; */\n  /* font-size: 3rem; */\n  /* text-align: center; */\n  /* margin-bottom: 3rem; */\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  /* font-size: 1.5rem; */\n  /* color: ", "; */\n  /* text-align: center; */\n"], ["\n  /* font-size: 1.5rem; */\n  /* color: ", "; */\n  /* text-align: center; */\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n   text-transform: uppercase;\n   color: ", ";\n   text-align: center;\n   width: 100%;\n   margin-top: 2rem;\n   font-size: 1.4rem;\n"], ["\n   text-transform: uppercase;\n   color: ", ";\n   text-align: center;\n   width: 100%;\n   margin-top: 2rem;\n   font-size: 1.4rem;\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n   width: 14em;\n   width: 14em;\n   display: block;\n   position: relative;\n   margin: 0 auto 3em;\n"], ["\n   width: 14em;\n   width: 14em;\n   display: block;\n   position: relative;\n   margin: 0 auto 3em;\n"]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n\n    padding: 1em;\n    background-color: #dc3545;\n    color: #fff;\n    margin-bottom: 2em;\n\n"], ["\n\n    padding: 1em;\n    background-color: #dc3545;\n    color: #fff;\n    margin-bottom: 2em;\n\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(45);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _input = __webpack_require__(23);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _autofill = __webpack_require__(37);
	
	var _autofill2 = _interopRequireDefault(_autofill);
	
	var _suburbs = __webpack_require__(53);
	
	var _suburbs2 = _interopRequireDefault(_suburbs);
	
	var _fileSaver = __webpack_require__(132);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	var _rightCircleWhite = __webpack_require__(20);
	
	var _rightCircleWhite2 = _interopRequireDefault(_rightCircleWhite);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var theme = {
	   color: _vars.colors.inactiveColor,
	   backgroundColor: "transparent",
	   paddingLeft: "1rem",
	   fontSize: "1.5rem"
	};
	
	var DevelopmentUpdateForm = function (_React$Component) {
	   _inherits(DevelopmentUpdateForm, _React$Component);
	
	   function DevelopmentUpdateForm() {
	      _classCallCheck(this, DevelopmentUpdateForm);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	      var url = void 0;
	      if (typeof window !== "undefined") {
	         url = window.location.href.replace("https://", "").replace("http://", "").replace(/\/$/, "");
	      } else {
	         url = "";
	      }
	      _this.state = {
	         formStatus: "incomplete",
	         values: {},
	         url: url,
	         declineSuburb: false
	      };
	      return _this;
	   }
	
	   DevelopmentUpdateForm.prototype.updateForm = function updateForm(e) {
	      var values = this.state.values;
	      if (e.target.getAttribute("name") !== "Postcode") {
	         values[e.target.getAttribute("name")] = e.target.value;
	         this.setState({ values: values });
	      } else {
	         return false;
	      }
	   };
	
	   DevelopmentUpdateForm.prototype.componentDidMount = function componentDidMount() {
	
	      this.updateForm = this.updateForm.bind(this);
	      this.handleSubmit = this.handleSubmit.bind(this);
	   };
	
	   DevelopmentUpdateForm.prototype.handleSubmit = function handleSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var submitBtn = document.getElementById("submit");
	      submitBtn.style.cursor = "progress";
	      submitBtn.disabled = true;
	      submitBtn.innerHTML = 'LOADING';
	      var fields = [].slice.call(e.target.querySelectorAll("[name]"));
	      fields.map(function (f) {
	         var values = _this2.state.values;
	         values[f.getAttribute("name")] = f.value;
	      });
	      var values = _extends({}, this.state.values);
	
	      // console.log(values);
	
	      fetch("https://vds9c5imf1.execute-api.ap-southeast-2.amazonaws.com/prod/yarrabend-mailchimp-development-updates", {
	         method: "POST",
	         headers: { "Content-Type": "application/json" },
	         body: JSON.stringify(values)
	      }).then(function (res) {
	         return res.json();
	      }).then(function (json) {
	         if (json.errorMessage) {
	            alert('Error submitting request please call +61 (0)3 9573 8320');
	         } else {
	            var formStatus = "complete";
	            _this2.setState({ formStatus: formStatus });
	         }
	      }).catch(function (err) {
	         return console.log(err);
	      });
	   };
	
	   DevelopmentUpdateForm.prototype.render = function render() {
	
	      return _react2.default.createElement(
	         Container,
	         { popup: this.props.popup, shown: this.props.shown },
	         this.props.popup && _react2.default.createElement(Close, { onClick: this.props.toggleForm }),
	         this.state.formStatus === "complete" ? _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	               ThankYouText,
	               { className: 'form__thankyou' },
	               "Thank you your registration was successfully submitted."
	            )
	         ) : _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: theme },
	            _react2.default.createElement(
	               "div",
	               null,
	               _react2.default.createElement(
	                  Form,
	                  { action: "", onSubmit: this.handleSubmit },
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "first_name",
	                        label: "First Name",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Field,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "last_name",
	                        label: "Surname",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     FieldFull,
	                     null,
	                     _react2.default.createElement(_input2.default, {
	                        name: "email",
	                        label: "Email address",
	                        required: true,
	                        onChange: this.updateForm
	                     })
	                  ),
	                  _react2.default.createElement(
	                     Submit,
	                     { id: "submit", square: this.props.square },
	                     _react2.default.createElement(
	                        "span",
	                        null,
	                        "Keep me updated"
	                     )
	                  )
	               )
	            )
	         )
	      );
	   };
	
	   return DevelopmentUpdateForm;
	}(_react2.default.Component);
	
	exports.default = DevelopmentUpdateForm;
	
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Close = _styledComponents2.default.div(_templateObject2, _vars.colors.blank, vars.time);
	
	var Form = _styledComponents2.default.form(_templateObject3, vars.padding.inner, _functions.below.tablet(_templateObject4), _functions.below.mobile(_templateObject5));
	
	var Field = _styledComponents2.default.div(_templateObject6, _vars.colors.inactiveColor, _functions.below.mobile(_templateObject7));
	
	var FieldFull = _styledComponents2.default.div(_templateObject8, _vars.colors.inactiveColor, _functions.below.mobile(_templateObject7));
	
	var Submit = _styledComponents2.default.button(_templateObject9, _vars.colors.body, _vars.colors.blank, vars.padding.inner / 2);
	
	var Heading = _styledComponents2.default.p(_templateObject10, _vars.colors.brandHighlight);
	
	var ThankYouText = _styledComponents2.default.p(_templateObject11, _vars.colors.white);
	
	var FormNote = _styledComponents2.default.p(_templateObject12, _vars.colors.brandHighlight);
	
	var Logo = _styledComponents2.default.img(_templateObject13);
	
	var FormError = _styledComponents2.default.p(_templateObject14);
	module.exports = exports["default"];

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n   /* border: 1px solid gray; */\n\n   h3 {\n      padding: 1rem 1rem;\n      width: 100%;\n      border: 1px solid ", ";\n      border-width: 1px 0 0 0;\n\n      &:last-of-type {\n         border-bottom: 1px solid ", ";\n      }\n\n      a {\n         display: block;\n         text-decoration: none;\n         position: relative;\n         padding: 1rem 0;\n\t\t\t\t\tspan{\n\t\t\t\t\t\tmax-width: calc(100% - 5rem);\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t}\n         &:after {\n            content: \"\";\n            width: 3rem;\n            height: 3rem;\n            /* margin-top: .3rem; */\n            background: url(", ") no-repeat;\n            position: absolute;\n            transform: translate(-50%, -50%);\n            right: 0;\n            top: 50%;\n         }\n      }\n   }\n\n   .btn {\n      background: ", ";\n      color: white;\n      /* width: 48rem; */\n      margin: 3rem 0 7rem;\n\n      ", ";\n   }\n\n   .btn.btn-square span {\n      /* display: block; */\n      text-align: center;\n\n      ", ";\n   }\n\n   margin-bottom:7rem;\n"], ["\n   /* border: 1px solid gray; */\n\n   h3 {\n      padding: 1rem 1rem;\n      width: 100%;\n      border: 1px solid ", ";\n      border-width: 1px 0 0 0;\n\n      &:last-of-type {\n         border-bottom: 1px solid ", ";\n      }\n\n      a {\n         display: block;\n         text-decoration: none;\n         position: relative;\n         padding: 1rem 0;\n\t\t\t\t\tspan{\n\t\t\t\t\t\tmax-width: calc(100% - 5rem);\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t}\n         &:after {\n            content: \"\";\n            width: 3rem;\n            height: 3rem;\n            /* margin-top: .3rem; */\n            background: url(", ") no-repeat;\n            position: absolute;\n            transform: translate(-50%, -50%);\n            right: 0;\n            top: 50%;\n         }\n      }\n   }\n\n   .btn {\n      background: ", ";\n      color: white;\n      /* width: 48rem; */\n      margin: 3rem 0 7rem;\n\n      ", ";\n   }\n\n   .btn.btn-square span {\n      /* display: block; */\n      text-align: center;\n\n      ", ";\n   }\n\n   margin-bottom:7rem;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n         width: 28rem;\n      "], ["\n         width: 28rem;\n      "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n         font-size: 1.2rem;\n      "], ["\n         font-size: 1.2rem;\n      "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n   padding-bottom: ", "rem;\n   padding-right: ", "rem;\n   border-right: ", "px solid ", ";\n\timg{\n\t\twidth: 200px;\n\t}\n   ", ";\n\n"], ["\n   padding-bottom: ", "rem;\n   padding-right: ", "rem;\n   border-right: ", "px solid ", ";\n\timg{\n\t\twidth: 200px;\n\t}\n   ", ";\n\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n      padding-bottom: 0;\n      border-right: none;\n   "], ["\n      padding-bottom: 0;\n      border-right: none;\n   "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n   padding-left: ", "rem;\n\n   ", ";\n\n   h4 {\n      padding-bottom: 3rem;\n   }\n   h5 {\n      font-size: ", "rem;\n      padding-bottom: ", "rem;\n\n   }\n"], ["\n   padding-left: ", "rem;\n\n   ", ";\n\n   h4 {\n      padding-bottom: 3rem;\n   }\n   h5 {\n      font-size: ", "rem;\n      padding-bottom: ", "rem;\n\n   }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n      border-left: none;\n      padding-left: 0;\n   "], ["\n      border-left: none;\n      padding-left: 0;\n   "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n\n   padding-bottom: ", "rem;\n\n   h3 {\n\t\tfont-family: ", ";\n\t\tfont-weight:normal;\n\n\t\tfont-size:2.3rem;\n\t\tfont-weight: normal;\n\t\t", "\n\t\t", "\n      padding-bottom: ", "rem;\n   }\n\t .grid .col{\n\t\t min-height: 30rem;\n\t\t ", "\n\t }\n   .grid .col:first-of-type {\n      border-left: 1px solid ", ";\n\t\t\tpadding-left: ", "rem;\n\t\t\t", "\n   }\n\n   .border-left {\n      border-left: 1px solid ", ";\n\t\t\tpadding-left: ", "rem;\n   }\n   .mob-border-left {\n      border-left-width: 0;\n\t\t\tpadding-left: ", "rem;\n\n      ", "\n   }\n"], ["\n\n   padding-bottom: ", "rem;\n\n   h3 {\n\t\tfont-family: ", ";\n\t\tfont-weight:normal;\n\n\t\tfont-size:2.3rem;\n\t\tfont-weight: normal;\n\t\t", "\n\t\t", "\n      padding-bottom: ", "rem;\n   }\n\t .grid .col{\n\t\t min-height: 30rem;\n\t\t ", "\n\t }\n   .grid .col:first-of-type {\n      border-left: 1px solid ", ";\n\t\t\tpadding-left: ", "rem;\n\t\t\t", "\n   }\n\n   .border-left {\n      border-left: 1px solid ", ";\n\t\t\tpadding-left: ", "rem;\n   }\n   .mob-border-left {\n      border-left-width: 0;\n\t\t\tpadding-left: ", "rem;\n\n      ", "\n   }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size:2.3rem;\n\t\t"], ["\n\t\t\tfont-size:2.3rem;\n\t\t"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n\t\t\tfont-size:2rem;\n\t\t"], ["\n\t\t\tfont-size:2rem;\n\t\t"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n\t\t \tmin-height: 0;\n\t\t\t padding-left: ", "rem;\n\t\t\t border-left: 1px solid ", ";\n\n\t\t "], ["\n\t\t \tmin-height: 0;\n\t\t\t padding-left: ", "rem;\n\t\t\t border-left: 1px solid ", ";\n\n\t\t "]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n\t\t\t\tpadding-left: ", "rem;\n\t\t\t"], ["\n\t\t\t\tpadding-left: ", "rem;\n\t\t\t"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n         border-left-width: 0.2rem;\n      "], ["\n         border-left-width: 0.2rem;\n      "]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _vars = __webpack_require__(7);
	
	var vars = _interopRequireWildcard(_vars);
	
	var _functions = __webpack_require__(6);
	
	var _news_card = __webpack_require__(61);
	
	var _news_card2 = _interopRequireDefault(_news_card);
	
	var _prismicReactjs = __webpack_require__(19);
	
	var _header = __webpack_require__(21);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _photo = __webpack_require__(91);
	
	var _photo2 = _interopRequireDefault(_photo);
	
	var _rightCircle = __webpack_require__(51);
	
	var _rightCircle2 = _interopRequireDefault(_rightCircle);
	
	var _developmentUpdateForm = __webpack_require__(313);
	
	var _developmentUpdateForm2 = _interopRequireDefault(_developmentUpdateForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var developmentUpdates = function (_React$Component) {
	   _inherits(developmentUpdates, _React$Component);
	
	   function developmentUpdates() {
	      _classCallCheck(this, developmentUpdates);
	
	      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	   }
	
	   developmentUpdates.prototype.componentDidMount = function componentDidMount() {
	      this.props.updateMeta(this.props.data.prismicDevelopmentUpdates.data.meta_title.text, this.props.data.prismicDevelopmentUpdates.data.meta_description);
	      this.props.togglePopup(false);
	      this.props.updateProductHide(false);
	      this.props.updateFooterVisible(true);
	   };
	
	   developmentUpdates.prototype.render = function render() {
	      var data = this.props.data.prismicDevelopmentUpdates.dataString;
	      data = JSON.parse(this.props.data.prismicDevelopmentUpdates.dataString);
	      var slides = [{
	         img: {
	            alt: "",
	            url: "" + data.body[0].primary.hero_image.url,
	            mobile: {
	               url: "" + data.body[0].primary.hero_image.url
	            }
	         },
	         logo: {},
	         image_anchor: "Top",
	         header: [{
	            type: "heading2",
	            text: "" + data.body[0].primary.header[0].text,
	            spans: []
	         }],
	         subheader: [{
	            type: "heading3",
	            text: "" + data.body[0].primary.subheader[0].text,
	            spans: []
	         }],
	         text: data.body[0].primary.text,
	         link: null
	      }];
	
	      return _react2.default.createElement(
	         "div",
	         null,
	         _react2.default.createElement(_header2.default, { theme: "dark", menu: this.props.data.prismicMainNavigation.data }),
	         _react2.default.createElement(
	            "div",
	            { className: "bg mini white" },
	            _react2.default.createElement(_photo2.default, { slides: slides, hero: "false", key: 0 }),
	            _react2.default.createElement(
	               Container,
	               { isHero: false },
	               _react2.default.createElement(
	                  "div",
	                  { className: "grid " },
	                  _react2.default.createElement(
	                     "div",
	                     { className: "inner" },
	                     _react2.default.createElement(
	                        MainCopy,
	                        { className: "col col-xs-12 col-06 " },
	                        slides[0].logo && _react2.default.createElement("img", { src: slides[0].logo.url }),
	                        _prismicReactjs.RichText.render(slides[0].header),
	                        _prismicReactjs.RichText.render(slides[0].subheader)
	                     ),
	                     _react2.default.createElement(
	                        Text,
	                        { className: "col col-xs-12 col-04" },
	                        _prismicReactjs.RichText.render(slides[0].text),
	                        _react2.default.createElement(_developmentUpdateForm2.default, null)
	                     )
	                  )
	               )
	            ),
	            _react2.default.createElement(
	               DocContainer,
	               { className: "grid" },
	               data.body[0].items.map(function (m) {
	                  return _react2.default.createElement(
	                     "h3",
	                     null,
	                     _react2.default.createElement(
	                        "a",
	                        { href: m.document_link.url, target: "_blank" },
	                        _react2.default.createElement(
	                           "span",
	                           null,
	                           m.document_title[0].text
	                        )
	                     )
	                  );
	               })
	            )
	         )
	      );
	   };
	
	   return developmentUpdates;
	}(_react2.default.Component);
	
	var DocContainer = _styledComponents2.default.div(_templateObject, vars.colors.offColor, vars.colors.offColor, _rightCircle2.default, vars.colors.body, _functions.below.mobile(_templateObject2), _functions.below.mobile(_templateObject3));
	
	var MainCopy = _styledComponents2.default.div(_templateObject4, vars.padding.inner, vars.padding.inner, function (props) {
	   return props.isHero ? '1' : '1';
	}, vars.colors.body, _functions.below.tablet(_templateObject5));
	var Text = _styledComponents2.default.div(_templateObject6, vars.padding.inner, _functions.below.tablet(_templateObject7), vars.padding.inner / 2, vars.padding.inner / 5);
	
	var Container = _styledComponents2.default.div(_templateObject8, vars.padding.inner * 2, vars.fonts.main, _functions.below.tablet(_templateObject9), _functions.below.mobile(_templateObject10), vars.padding.mobInner, _functions.below.tablet(_templateObject11, vars.padding.mobInner, vars.colors.body), vars.colors.body, vars.padding.inner, _functions.below.tablet(_templateObject12, vars.padding.mobInner), vars.colors.body, vars.padding.inner, vars.padding.inner, _functions.below.tablet(_templateObject13));
	
	exports.default = developmentUpdates;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-development-updates-js-2062c346002568fa522e.js